/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import styles from './styles.module.scss';
import TextButton from 'components/button/TextButton';
import { useTranslation } from 'react-i18next';

type Props = {
  children?: React.ReactNode;
  onLoadMore?: () => void;
  isLoading?: boolean;
  isFirstLoading?: boolean;
  isEnded?: boolean;
  loadingElement?: React.ReactNode;
};

export default function LoadMoreList({
  children,
  isEnded = false,
  isFirstLoading,
  isLoading,
  loadingElement,
  onLoadMore,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.body}>
        {!isFirstLoading && children}
        {(isLoading || isFirstLoading) && loadingElement}
      </div>
      {!isEnded && (
        <TextButton
          title={t('button.load-more')}
          size="small"
          variant="solid"
          color="warning"
          style={{
            width: 'fit-content',
          }}
          loading={isLoading}
          onClick={onLoadMore}
        />
      )}
    </div>
  );
}
